// extracted by mini-css-extract-plugin
export default {"productCard":"ProductCard_productCard__BSPTJ","heart":"ProductCard_heart__AWDyK","title":"ProductCard_title__iCUEZ","btn":"ProductCard_btn__jPZJF"};